module.exports = __webpack_public_path__ + "img/MM.22176a5f.svg";